import type { ViewConfigRow } from '@streamlain/view-config';

import type { Row } from '../../../types/view-datasource.types';

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 63);
}

export function deriveRowSlug(row: Row, viewConfig: ViewConfigRow): string {
  const slugColumnId = viewConfig.seoSlugCol;
  if (slugColumnId) {
    const cellValue = row.cells[slugColumnId];
    if (cellValue != null && String(cellValue).trim() !== '') {
      return slugify(String(cellValue));
    }
  }
  return row.id;
}
